// Biznes avtomatlashtirish — xizmat sahifasi kontenti (uz / ru)
// Shakl: src/content/services/_shape.js

const uz = {
    meta: {
        title: "Biznes avtomatlashtirish — qo'lda qilinadigan ishni tizimga o'tkazish | Innobek",
        description:
            "Biznes avtomatlashtirish: Excel va qog'oz o'rniga ishlaydigan tizim, CRM va ERP integratsiyasi, hujjat va hisobotlarni avtomatlashtirish. Narx 15 000 000 so'mdan.",
        keywords: [
            "biznes avtomatlashtirish",
            "jarayonlarni avtomatlashtirish",
            "excel o'rniga tizim",
            "crm joriy qilish",
            "hujjat aylanishi avtomatlashtirish",
            "integratsiya",
            "ombor hisobi dasturi",
            "avtomatlashtirish narxi",
        ],
    },

    hero: {
        eyebrow: "Biznes avtomatlashtirish",
        h1: "Biznes avtomatlashtirish: qo'lda qilinadigan ishni tizimga o'tkazamiz",
        lead:
            "Xodimlaringiz vaqtining katta qismi bir xil harakatlarga ketadi: ma'lumotni bir joydan ikkinchisiga ko'chirish, hisobot yig'ish, hujjat to'ldirish. Biz shu ishlarni tizimga beramiz — odam esa qaror qabul qilish bilan shug'ullanadi.",
        ctaPrimary: "Jarayonni baholash so'rash",
        ctaSecondary: "Narx va muddatni ko'rish",
        proof: [
            "200+ topshirilgan loyiha",
            "Avval jarayonni o'rganamiz, keyin kod yozamiz",
            "Mavjud dasturlaringiz bilan integratsiya",
            "Bosqichma-bosqich joriy qilish",
        ],
    },

    intro: {
        h: "Biznes avtomatlashtirish nima va u qachon kerak bo'ladi?",
        p: [
            "Ko'p kompaniyada ish shunday ketadi: sotuvchi arizani Telegramdan oladi, uni Excelga yozadi, omborchiga qo'ng'iroq qiladi, buxgalter yana boshqa faylga kiritadi. Har qadamda odam bor, demak har qadamda xato bo'lishi mumkin. Oy oxirida esa hech kim aniq raqamni ayta olmaydi.",
            "Biznes avtomatlashtirish — bu shu zanjirni bitta tizimga yig'ish. Ariza kelganda u avtomatik ro'yxatga tushadi, mas'ulga biriktiriladi, ombor qoldig'i o'zi yangilanadi, hisobot esa har kuni o'zi shakllanadi. Xodim ma'lumotni ko'chirmaydi — u mijoz bilan gaplashadi.",
            "Muhim nuqta: avtomatlashtirish tartibsizlikni tuzatmaydi, uni tezlashtiradi. Agar jarayon tushunarsiz bo'lsa, uni dasturga o'tkazish faqat chalkashlikni ko'paytiradi. Shuning uchun biz ishni jarayonni chizishdan boshlaymiz: kim nima qiladi, qaysi ma'lumot qayerdan keladi, qaysi qadam ortiqcha. Ko'pincha shu bosqichda qadamlarning 20–30% olib tashlanadi.",
            "Innobek tayyor qutidagi yechimni majburan sotmaydi. Ba'zi vazifalar uchun mavjud CRM yetarli — biz uni sozlab, integratsiya qilib beramiz. Ba'zi jarayonlar esa tayyor dasturga sig'maydi: o'sha paytda o'z tizimingizni yozamiz. Qaysi yo'l arzonroq ekanini birinchi tahlildan keyin aytamiz.",
            "Bu xizmat har doim ham o'zini oqlamaydi. Agar oyiga 20–30 ta buyurtmangiz bo'lsa va jamoa uch kishidan iborat bo'lsa, murakkab tizim ortiqcha xarajat bo'ladi. Avtomatlashtirish aniq foyda beradigan chegara — bir xil amal kuniga o'nlab marta takrorlanganda yoki xatolar puliga aylanganda.",
        ],
    },

    definition: {
        term: "Biznes avtomatlashtirish nima?",
        text:
            "Biznes avtomatlashtirish — kompaniyadagi takrorlanuvchi qo'l mehnatini (ma'lumot kiritish, hisobot yig'ish, hujjat tayyorlash, xabar yuborish) dasturiy tizimga o'tkazish. Maqsad — xatoni kamaytirish, vaqtni tejash va jarayonni shaffof qilish.",
    },

    included: {
        eyebrow: "Nimalar kiradi",
        h: "Avtomatlashtirish loyihasiga nimalar kiradi",
        sub: "Ro'yxatdan sizning jarayoningizga tegishli qismi tanlanadi.",
        items: [
            "Hozirgi jarayonni o'rganish va chizib chiqish",
            "Yo'qotiladigan vaqt va xatolarni hisoblash",
            "Texnik topshiriq va yechim arxitekturasi",
            "Ariza va buyurtmalarni yagona oynada yig'ish",
            "Mijozlar bazasi va sotuv bosqichlari (CRM)",
            "Ombor qoldig'i va harakatini avtomatik hisobi",
            "Shartnoma, hisob-faktura va aktlarni avtomatik shakllantirish",
            "Telegram orqali bildirishnoma va tasdiqlash",
            "To'lov tizimlari va bank integratsiyasi",
            "1C, Excel yoki mavjud bazadan ma'lumot ko'chirish",
            "Rollar va kirish huquqlari: kim nimani ko'radi",
            "Rahbar uchun jonli dashboard va hisobotlar",
            "Xodimlarni o'qitish va video qo'llanma",
            "Ishga tushirilgandan keyin 1 oy bepul kuzatuv",
        ],
    },

    benefits: {
        eyebrow: "Nima beradi",
        h: "Avtomatlashtirish nimani o'zgartiradi",
        sub: "Quyidagilar biz kuzatgan odatiy natijalar — kafolat emas, mo'ljal.",
        items: [
            {
                t: "Xodim vaqti bo'shaydi",
                d: "Ma'lumot ko'chirish va hisobot yig'ishga ketadigan kuniga 1–3 soat qaytadi. Odatda bu bitta xodimni yollashdan arzonroq tushadi.",
            },
            {
                t: "Xato kamayadi",
                d: "Qo'lda kiritishda xato muqarrar: noto'g'ri narx, ikki marta yozilgan buyurtma, yo'qolgan ariza. Tizimda tekshiruv qoidalari shu holatlarni kiritishga yo'l qo'ymaydi.",
            },
            {
                t: "Raqamlar real vaqtda ko'rinadi",
                d: "Oy oxirini kutish shart emas. Sotuv, qoldiq va qarzdorlik istalgan kunda bitta ekranda turadi.",
            },
            {
                t: "Ariza yo'qolmaydi",
                d: "Har bir murojaat ro'yxatga tushadi va mas'ulga biriktiriladi. Javob berilmagan ariza rahbar ekranida qizil bo'lib turadi.",
            },
            {
                t: "Jarayon odamga bog'liq bo'lmaydi",
                d: "Xodim ta'tilga chiqsa yoki ishdan ketsa, ma'lumot uning daftarida yoki shaxsiy faylida qolmaydi. Hammasi tizimda.",
            },
            {
                t: "Hujjatlar bir necha soniyada",
                d: "Shartnoma, hisob-faktura va akt shablondan avtomatik to'ldiriladi. Rekvizitni qayta terish va undagi xatolar yo'qoladi.",
            },
            {
                t: "Nazorat oson bo'ladi",
                d: "Har amal kim tomonidan va qachon bajarilgani yozib boriladi. Bahsli holatlarda kim nima qilgani aniq ko'rinadi.",
            },
            {
                t: "O'sishga tayyor bo'lasiz",
                d: "Buyurtmalar ikki barobar ko'paysa, tizim shunchaki ko'proq yozuvni qayta ishlaydi. Qo'l mehnatida esa yana odam yollash kerak bo'lardi.",
            },
            {
                t: "Mijoz javobni tezroq oladi",
                d: "Ariza holati, to'lov va yetkazib berish haqidagi xabarlar avtomatik yuboriladi. Mijoz qo'ng'iroq qilib so'rashi shart emas, operator yuki esa kamayadi.",
            },
        ],
    },

    audience: {
        eyebrow: "Kimlar uchun",
        h: "Avtomatlashtirish kimlarga foyda beradi",
        sub: "Quyidagi belgilardan ikkitasi bo'lsa, hisob-kitob qilib ko'rishga arziydi.",
        items: [
            {
                t: "Excelda ishlaydigan kompaniyalar",
                d: "Fayllar ko'payib ketgan, kim qaysi versiyada ishlayotgani noma'lum, formulalar buzilgan. Bu avtomatlashtirishga eng ko'p uchraydigan sabab.",
            },
            {
                t: "Savdo va distribyutorlar",
                d: "Ko'p pozitsiya, ko'p mijoz, ombordagi qoldiq doim o'zgaradi. Qo'lda hisob bir haftadayoq haqiqatdan uzoqlashadi.",
            },
            {
                t: "Xizmat ko'rsatuvchi tashkilotlar",
                d: "Ariza, usta, jadval va bajarilgan ish akti. Bu zanjirni telefon va daftar bilan boshqarish tez chalkashadi.",
            },
            {
                t: "Ishlab chiqarish korxonalari",
                d: "Xomashyo, ishlab chiqarish rejasi, tayyor mahsulot va tannarx. Bu yerda bitta noto'g'ri raqam butun hisobni buzadi.",
            },
            {
                t: "Filiallari bor bizneslar",
                d: "Har filial o'z tartibida ishlaydi va markazga turli formatda hisobot yuboradi. Yagona tizim shu farqni yo'q qiladi.",
            },
            {
                t: "Tez o'sayotgan jamoalar",
                d: "10 kishi uchun ishlagan tartib 30 kishida buziladi. Tizimni o'sish boshlangan paytda qo'yish keyingidan arzonroq.",
            },
            {
                t: "Hujjat ko'p bo'lgan sohalar",
                d: "Logistika, qurilish, tibbiyot va ta'lim. Shablondan avtomatik hujjat tayyorlash bu yerda eng tez natija beradi.",
            },
            {
                t: "Tender va davlat buyurtmasi bilan ishlovchilar",
                d: "Muddat, hujjat va javobgarlik qat'iy. Tizim har bosqichni yozib boradi, shuning uchun tekshiruvga ma'lumot tayyorlash bir necha daqiqa oladi.",
            },
        ],
    },

    pricing: {
        eyebrow: "Narxlar",
        h: "Biznes avtomatlashtirish qancha turadi",
        sub: "Narx jarayonlar soni va integratsiyalar murakkabligiga bog'liq.",
        note:
            "Aniq summa birinchi tahlildan keyin beriladi: 2–5 kun ichida jarayoningizni o'rganamiz va yozma taklif yuboramiz. Katta loyihalar bosqichlarga bo'linadi — har bosqich alohida to'lanadi va alohida ishga tushadi, shuning uchun butun byudjetni bir yo'la ajratish shart emas. Ishga tushirilgandan keyin texnik qo'llab-quvvatlash oyiga 3 500 000 so'mdan. Server va uchinchi tomon xizmatlari to'lovlari alohida. Narxlarga QQS kiritilmagan.",
        tiers: [
            {
                name: "Bitta jarayon",
                tagline: "Eng og'riqli joydan boshlash",
                price: "15 000 000",
                priceNote: "so'mdan",
                term: "3–5 hafta",
                best: "Bitta bo'limning aniq bir vazifasi",
                features: [
                    "Bitta jarayonni tahlil qilish va chizish",
                    "Shu jarayon uchun tizim yoki modul",
                    "2–3 ta integratsiya (Telegram, to'lov, Excel)",
                    "5 tagacha foydalanuvchi uchun rol sozlamalari",
                    "Ma'lumotlarni ko'chirish",
                    "Xodimlarni o'qitish (1 sessiya)",
                    "1 oy bepul kuzatuv va tuzatish",
                ],
            },
            {
                name: "Bo'lim darajasi",
                tagline: "Sotuv, ombor yoki servis to'liq",
                price: "45 000 000",
                priceNote: "so'mdan",
                term: "2–3 oy",
                best: "Bitta yo'nalishni boshdan oxir avtomatlashtirish",
                featured: true,
                features: [
                    "3–5 ta bog'liq jarayonni tahlil qilish",
                    "CRM yoki ichki tizim, rollar va huquqlar bilan",
                    "Ombor, hujjat va hisobot modullari",
                    "1C, bank va to'lov tizimlari integratsiyasi",
                    "Rahbar uchun dashboard va eksport",
                    "Mobil brauzerda to'liq ishlaydigan interfeys",
                    "Video qo'llanma va 2 o'quv sessiyasi",
                    "2 oy bepul kuzatuv",
                ],
            },
            {
                name: "Kompaniya darajasi",
                tagline: "Bir nechta bo'lim va filial",
                price: "110 000 000",
                priceNote: "so'mdan",
                term: "4–8 oy",
                best: "Filiallari yoki ishlab chiqarishi bor kompaniyalar",
                features: [
                    "To'liq jarayon auditi va yo'l xaritasi",
                    "Bosqichma-bosqich joriy qilish rejasi",
                    "ERP darajasidagi modullar: ishlab chiqarish, moliya, kadrlar",
                    "Filiallar o'rtasida yagona ma'lumot bazasi",
                    "Murakkab huquqlar tizimi va audit jurnali",
                    "Mavjud dasturlar bilan API integratsiya",
                    "Yuklamaga chidamli arxitektura va zaxira nusxa",
                    "Alohida loyiha menejeri va oylik hisobot",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Jarayon",
        h: "Avtomatlashtirish qanday olib boriladi",
        sub: "Odatda birinchi suhbatdan birinchi ishlaydigan modulgacha 4–8 hafta.",
        steps: [
            {
                t: "Tanishuv suhbati",
                time: "1 kun",
                d: "Qaysi ish ko'p vaqt olayotganini so'raymiz. Shu suhbatdayoq avtomatlashtirish sizga foydali bo'ladimi yoki yo'qmi — ochiq aytamiz.",
            },
            {
                t: "Jarayonni o'rganish",
                time: "3–5 kun",
                d: "Xodimlar bilan gaplashamiz, hujjat va fayllarni ko'ramiz. Natijada hozirgi jarayon chizmasi va yo'qotiladigan vaqt hisobi bo'ladi.",
            },
            {
                t: "Yechim va taklif",
                time: "2–4 kun",
                d: "Nimani tayyor dastur bilan, nimani o'z tizimimiz bilan yopish kerakligini yozamiz. Narx, muddat va bosqichlar aniqlanadi.",
            },
            {
                t: "Prototip",
                time: "1–2 hafta",
                d: "Asosiy ekranlarni Figmada ko'rsatamiz. Xodimlar ular bilan ishlab ko'radi — noqulaylik kod yozilmasdan topiladi.",
            },
            {
                t: "Ishlab chiqish",
                time: "3–10 hafta",
                d: "Modul-modul yig'iladi. Har 2 haftada tayyor qismni ko'rsatamiz va siz uni sinovdan o'tkazasiz.",
            },
            {
                t: "Ma'lumot ko'chirish va sinov",
                time: "1–2 hafta",
                d: "Excel yoki eski bazadan ma'lumot o'tkaziladi va tekshiriladi. Bir muddat eski va yangi tartib parallel ishlaydi.",
            },
            {
                t: "Ishga tushirish va o'qitish",
                time: "1 hafta",
                d: "Xodimlar o'qitiladi, video qo'llanma beriladi. Birinchi oy davomida savollarga tez javob beramiz va kamchiliklarni tuzatamiz.",
            },
        ],
    },

    samples: {
        eyebrow: "Namunalar",
        h: "Avtomatlashtirish loyihalarimiz",
        sub: "Lift servisi, logistika, o'qitish va xavfsizlik sohalarida qurilgan ishlaydigan tizimlar.",
        cta: "Barcha loyihalarni ko'rish",
        slugs: ["tezlift", "elma-lms", "logistatrans", "firewise", "grandpharm"],
    },

    faq: {
        eyebrow: "Savol-javob",
        h: "Ko'p beriladigan savollar",
        sub: "Biznes avtomatlashtirish bo'yicha eng ko'p so'raladigan savollar.",
        items: [
            {
                q: "Biznes avtomatlashtirish qancha turadi?",
                a: "Bitta jarayonni avtomatlashtirish 15 000 000 so'mdan boshlanadi. Butun bo'lim uchun tizim 45 000 000 so'mdan, filiallari bor kompaniya uchun to'liq yechim 110 000 000 so'mdan. Aniq summa jarayonlar soni, integratsiyalar va foydalanuvchilar soniga bog'liq. Birinchi tahlildan keyin yozma taklif beramiz — u bepul.",
            },
            {
                q: "Avtomatlashtirish qancha vaqt oladi?",
                a: "Bitta jarayon uchun 3–5 hafta, bo'lim darajasidagi tizim uchun 2–3 oy, kompaniya darajasida 4–8 oy. Biz katta loyihani bosqichlarga bo'lamiz: birinchi ishlaydigan modul odatda 4–8 haftada tayyor bo'ladi va shu paytdan foyda bera boshlaydi. Butun tizim tugashini kutish shart emas.",
            },
            {
                q: "Tayyor CRM olsam bo'lmaydimi?",
                a: "Ko'p holatda bo'ladi va biz shuni maslahat beramiz — tayyor yechim arzonroq va tezroq ishga tushadi. Lekin tayyor dastur sizning jarayoningizni bilmaydi. Agar hisob-kitob formulangiz, hujjat shakllaringiz yoki ishlab chiqarish mantig'ingiz o'ziga xos bo'lsa, tayyor tizimni moslashtirish o'z tizimini yozishdan qimmatga tushishi mumkin.",
            },
            {
                q: "Mavjud 1C va Excel fayllarim bilan nima bo'ladi?",
                a: "Ular yo'qolmaydi. Excel va eski bazadagi ma'lumotlar yangi tizimga ko'chiriladi va tekshiriladi. 1C bilan integratsiya ham qilinadi: kerakli ma'lumot ikki tomonga avtomatik uzatiladi, buxgalteriya esa odatdagidek 1Cda qoladi. Nima ko'chirilishi va nima eski joyida qolishi kerakligini loyiha boshida birga aniqlaymiz va yozma kelishamiz.",
            },
            {
                q: "Xodimlar yangi tizimni qabul qilmasa nima bo'ladi?",
                a: "Bu eng ko'p uchraydigan xavf, va u texnik emas. Shuning uchun biz prototipni aynan o'sha xodimlarga ko'rsatamiz va ularning izohlarini kod yozilmasdan oldin hisobga olamiz. Ishga tushirishda o'qitish sessiyasi va video qo'llanma beriladi, birinchi oy esa eski va yangi tartib parallel ishlashi mumkin.",
            },
            {
                q: "Avtomatlashtirish o'zini qachon oqlaydi?",
                a: "Aniq raqamni birinchi tahlilda hisoblab beramiz: qancha soat tejaladi va o'sha soatlar qancha turadi. Bitta jarayonni avtomatlashtirishda odatiy qaytish muddati 6–12 oy. Agar hisob-kitob 2 yildan uzun chiqsa, biz buni ochiq aytamiz va loyihani hozir boshlashni tavsiya qilmaymiz — arzonroq va soddaroq muqobilni taklif qilamiz.",
            },
            {
                q: "Ma'lumotlarim qayerda saqlanadi va xavfsizmi?",
                a: "Tanlov sizniki: O'zbekistondagi serverda, xorijiy bulutda yoki o'z serveringizda. Barcha kirish HTTPS orqali bo'ladi, parollar shifrlangan holda saqlanadi, har bir amal jurnalga yoziladi. Rollar tizimi kimning nimani ko'rishini cheklaydi. Zaxira nusxa har kuni olinadi va uni tiklash amalda sinovdan o'tkaziladi.",
            },
            {
                q: "Tizim kimga tegishli bo'ladi?",
                a: "Sizga. Kod sizning repozitoriyingizda olib boriladi, barcha intellektual mulk huquqlari shartnomada sizga biriktiriladi. Xohlasangiz, keyinchalik ishni boshqa jamoa bilan davom ettirasiz — buning uchun texnik hujjat, arxitektura tavsifi va server sozlamalari ham topshiriladi. Bizda hech qanday «kalit» yoki yashirin bog'liqlik qolmaydi.",
            },
            {
                q: "Qaysi jarayondan boshlash kerak?",
                a: "Eng ko'p vaqt oladigan va eng ko'p xato beradigan joydan. Ko'pincha bu ariza qabul qilish yoki ombor hisobi bo'ladi. Hammasini bir yo'la qamrab olishga urinish loyihani cho'zadi va xavfni oshiradi. Birinchi bosqich 4–8 haftada ishga tushsa, jamoa yangi tartibga ishonch bilan o'tadi.",
            },
            {
                q: "Tizim mobil telefonda ishlaydimi?",
                a: "Ha. Barcha interfeyslar mobil brauzerda to'liq ishlaydigan qilib qilinadi — sotuvchi, usta yoki omborchi telefondan kirib ishlashi mumkin. Alohida mobil ilova kerak bo'lsa — masalan, oflayn rejim yoki shtrix-kod skaneri uchun — u alohida loyiha sifatida, o'z muddati va byudjeti bilan baholanadi.",
            },
            {
                q: "Kichik biznes uchun ham mos keladimi?",
                a: "Ba'zan ha, ba'zan yo'q. Agar jamoangiz 3–5 kishi va oyiga 20–30 ta buyurtma bo'lsa, murakkab tizim ortiqcha. Bunday holatda Telegram bot, oddiy ariza yig'ish paneli yoki tayyor xizmat yetarli — narxi 5 000 000 so'mdan boshlanadi. Bu variantni ham taklif qilamiz.",
            },
            {
                q: "Ishga tushgandan keyin qo'llab-quvvatlash kerakmi?",
                a: "Tavsiya qilamiz, lekin bu majburiy shart emas. Har qanday tizim o'zgarib turadigan biznesga moslashishi kerak: yangi hisobot, yangi filial, qonunchilikdagi o'zgarish. Oylik qo'llab-quvvatlash 3 500 000 so'mdan boshlanadi va unga kuzatuv, zaxira nusxa, kichik o'zgarishlar hamda xatolarni tuzatish kiradi. Istalgan oyda to'xtatish mumkin.",
            },
        ],
    },

    cta: {
        h: "Qaysi ish sizda eng ko'p vaqt olayapti?",
        p: "Bepul tahlilda jarayoningizni ko'rib chiqamiz va qancha vaqt hamda pul tejash mumkinligini raqam bilan aytamiz. Agar avtomatlashtirish foyda bermasa — shuni ham aytamiz. Qo'ng'iroq: +998 90 954 12 62.",
        button: "Bepul tahlil so'rash",
        secondary: "Telegram orqali yozish",
    },

    images: [
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-hero.webp",
            alt: "Biznes avtomatlashtirish tizimi ekranida buyurtmalar va ombor qoldig'i",
            caption: "Ariza, ombor va hisobot bitta oynada — ma'lumotni qo'lda ko'chirish kerak emas.",
            prompt:
                "Wide hero image of a modern business dashboard on a desktop monitor in a bright office: order pipeline columns, inventory table, small charts, status badges. Clean light UI, blue and teal accents, abstract data (no readable company names). A person's hands rest near the keyboard, face not visible. Soft natural light, shallow depth of field, photographic, 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-before-after.webp",
            alt: "Qo'lda Excel bilan ishlash va avtomatlashtirilgan jarayon taqqoslamasi",
            caption: "Chapda — tarqoq fayllar va qo'ng'iroqlar. O'ngda — bitta zanjir.",
            prompt:
                "Split illustration comparing two workflows. Left side: tangled arrows between paper documents, spreadsheet icons, phone and sticky notes, muted grey-red tones. Right side: one clean linear pipeline of connected nodes with checkmarks, calm blue-green tones. Flat vector infographic style, plenty of white space, no text labels. 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-integratsiya.webp",
            alt: "CRM, ombor, 1C, to'lov tizimi va Telegram integratsiyasi sxemasi",
            caption: "Integratsiya — ma'lumot bir marta kiritiladi, qolgan tizimlarga o'zi tarqaladi.",
            prompt:
                "Clean isometric diagram of connected business systems: a central hub connected by glowing lines to blocks labelled abstractly with icons — CRM, warehouse, accounting, bank/payment, messenger bot, analytics. Light background, soft shadows, blue and violet palette, no readable text. Technical but friendly infographic style. 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-dashboard.webp",
            alt: "Rahbar uchun jonli dashboard: sotuv, qoldiq va qarzdorlik ko'rsatkichlari",
            caption: "Rahbar oy oxirini kutmaydi — raqamlar har kuni yangilanadi.",
            prompt:
                "Analytics dashboard UI shown on a laptop screen: KPI cards, a line chart of sales trend, a bar chart by branch, a small table of overdue payments. Modern flat design, light theme with one accent color, generic placeholder numbers, no real brand names. Straight-on view on a wooden desk, subtle reflections. 16:9.",
        },
    ],

    related: ["crm-tizimlar", "erp-tizimlar", "telegram-bot", "veb-ilovalar", "ai-integratsiya"],
};

const ru = {
    meta: {
        title: "Автоматизация бизнеса — перевод ручной работы в систему | Innobek",
        description:
            "Автоматизация бизнеса: система вместо Excel и бумаги, внедрение CRM и ERP, интеграции, автоматические документы и отчёты. Цена от 15 000 000 сум, срок от 3 недель.",
        keywords: [
            "автоматизация бизнеса",
            "автоматизация процессов",
            "система вместо excel",
            "внедрение crm",
            "автоматизация документооборота",
            "интеграция 1с",
            "складской учёт программа",
            "стоимость автоматизации",
        ],
    },

    hero: {
        eyebrow: "Автоматизация бизнеса",
        h1: "Автоматизация бизнеса: переводим ручную работу в систему",
        lead:
            "Большая часть рабочего времени сотрудников уходит на одни и те же действия: перенести данные из одного места в другое, собрать отчёт, заполнить документ. Мы отдаём эту работу системе — человек остаётся там, где нужны решения.",
        ctaPrimary: "Запросить разбор процесса",
        ctaSecondary: "Посмотреть цены и сроки",
        proof: [
            "200+ сданных проектов",
            "Сначала разбираем процесс, потом пишем код",
            "Интеграция с вашими текущими программами",
            "Внедрение по этапам, а не всё сразу",
        ],
    },

    intro: {
        h: "Что такое автоматизация бизнеса и когда она нужна",
        p: [
            "Во многих компаниях работа устроена так: продавец принимает заявку в Telegram, записывает её в Excel, звонит на склад, бухгалтер вносит те же данные в свой файл. На каждом шаге есть человек — значит, на каждом шаге возможна ошибка. А в конце месяца никто не может назвать точную цифру.",
            "Автоматизация бизнеса — это сборка всей цепочки в одну систему. Заявка попадает в список автоматически, назначается ответственному, остаток на складе пересчитывается сам, отчёт формируется ежедневно без участия людей. Сотрудник не переносит данные — он говорит с клиентом.",
            "Важный момент: автоматизация не лечит беспорядок, она его ускоряет. Если процесс непонятен, перенос его в программу только добавит путаницы. Поэтому мы начинаем с описания процесса: кто что делает, откуда берутся данные, какой шаг лишний. Обычно уже на этом этапе убирается 20–30% шагов.",
            "Innobek не навязывает коробочное решение. Для части задач хватает существующей CRM — мы настроим её и подключим интеграции. Другие процессы в готовую программу не помещаются: тогда пишем собственную систему. Какой путь окажется дешевле, скажем после первого разбора.",
            "Эта услуга оправдывает себя не всегда. Если у вас 20–30 заказов в месяц и команда из трёх человек, сложная система станет лишней статьёй расходов. Автоматизация даёт понятную выгоду там, где одно и то же действие повторяется десятки раз в день или где ошибки уже превращаются в деньги.",
        ],
    },

    definition: {
        term: "Что такое автоматизация бизнеса?",
        text:
            "Автоматизация бизнеса — это перевод повторяющейся ручной работы (ввод данных, сбор отчётов, подготовка документов, рассылка уведомлений) в программную систему. Цель — снизить число ошибок, сэкономить время и сделать процессы прозрачными.",
    },

    included: {
        eyebrow: "Что входит",
        h: "Что входит в проект по автоматизации",
        sub: "Из этого списка отбирается то, что относится к вашему процессу.",
        items: [
            "Изучение текущего процесса и его схема",
            "Расчёт потерянного времени и стоимости ошибок",
            "Техническое задание и архитектура решения",
            "Сбор заявок и заказов в одном окне",
            "База клиентов и воронка продаж (CRM)",
            "Автоматический учёт складских остатков и движений",
            "Автоформирование договоров, счетов и актов",
            "Уведомления и согласования через Telegram",
            "Интеграция с платёжными системами и банком",
            "Перенос данных из 1С, Excel или старой базы",
            "Роли и права доступа: кто что видит",
            "Живой дашборд и отчёты для руководителя",
            "Обучение сотрудников и видеоинструкции",
            "Месяц бесплатного сопровождения после запуска",
        ],
    },

    benefits: {
        eyebrow: "Что это даёт",
        h: "Что меняется после автоматизации",
        sub: "Ниже типичные результаты из нашей практики — это ориентир, а не гарантия.",
        items: [
            {
                t: "Освобождается время сотрудников",
                d: "Возвращаются 1–3 часа в день, которые уходили на перенос данных и сбор отчётов. Обычно это дешевле, чем нанять ещё одного человека.",
            },
            {
                t: "Меньше ошибок",
                d: "При ручном вводе ошибки неизбежны: не та цена, задвоенный заказ, потерянная заявка. Правила проверки в системе просто не дают сохранить такие данные.",
            },
            {
                t: "Цифры видны в реальном времени",
                d: "Не нужно ждать конца месяца. Продажи, остатки и дебиторка доступны в любой день на одном экране.",
            },
            {
                t: "Заявки не теряются",
                d: "Каждое обращение фиксируется и назначается ответственному. Просроченная заявка подсвечивается на экране руководителя.",
            },
            {
                t: "Процесс не зависит от человека",
                d: "Если сотрудник уходит в отпуск или увольняется, данные не остаются в его блокноте или личном файле. Всё хранится в системе.",
            },
            {
                t: "Документы за секунды",
                d: "Договор, счёт и акт заполняются из шаблона автоматически. Реквизиты не нужно перенабирать вручную, а ошибки в них исчезают.",
            },
            {
                t: "Контроль становится простым",
                d: "Каждое действие фиксируется с указанием автора и времени. В спорной ситуации видно, кто и что сделал.",
            },
            {
                t: "Вы готовы к росту",
                d: "Когда заказов станет вдвое больше, система просто обработает больше записей. При ручной работе пришлось бы нанимать людей.",
            },
            {
                t: "Клиент получает ответ быстрее",
                d: "Уведомления о статусе заявки, оплате и доставке уходят автоматически. Клиенту не нужно звонить и уточнять, а нагрузка на операторов падает.",
            },
        ],
    },

    audience: {
        eyebrow: "Кому подходит",
        h: "Кому автоматизация приносит пользу",
        sub: "Если совпадают хотя бы два пункта — стоит посчитать экономику.",
        items: [
            {
                t: "Компании, живущие в Excel",
                d: "Файлов стало слишком много, непонятно, кто в какой версии работает, формулы ломаются. Это самая частая причина обращения.",
            },
            {
                t: "Торговля и дистрибуция",
                d: "Много позиций, много клиентов, остаток меняется постоянно. Ручной учёт расходится с реальностью уже через неделю.",
            },
            {
                t: "Сервисные компании",
                d: "Заявка, мастер, расписание, акт выполненных работ. Управлять этой цепочкой по телефону и в блокноте быстро становится невозможно.",
            },
            {
                t: "Производственные предприятия",
                d: "Сырьё, план производства, готовая продукция и себестоимость. Здесь одна неверная цифра ломает весь расчёт.",
            },
            {
                t: "Бизнесы с филиалами",
                d: "Каждый филиал работает по-своему и присылает отчёты в разном формате. Единая система убирает эту разницу.",
            },
            {
                t: "Быстро растущие команды",
                d: "Порядок, работавший на 10 человек, рассыпается на 30. Поставить систему в момент роста дешевле, чем потом.",
            },
            {
                t: "Сферы с большим документооборотом",
                d: "Логистика, строительство, медицина и образование. Здесь автоматическое формирование документов даёт результат быстрее всего.",
            },
            {
                t: "Работающие с тендерами и госзаказом",
                d: "Жёсткие сроки, документы и ответственность. Система фиксирует каждый шаг, поэтому подготовка данных к проверке занимает минуты, а не дни.",
            },
        ],
    },

    pricing: {
        eyebrow: "Цены",
        h: "Сколько стоит автоматизация бизнеса",
        sub: "Цена зависит от количества процессов и сложности интеграций.",
        note:
            "Точную сумму называем после первого разбора: за 2–5 дней изучаем ваш процесс и присылаем письменное предложение. Крупные проекты делим на этапы — каждый оплачивается и запускается отдельно, поэтому весь бюджет сразу выделять не нужно. Техническая поддержка после запуска — от 3 500 000 сум в месяц. Оплата серверов и сторонних сервисов идёт отдельно. Цены указаны без НДС.",
        tiers: [
            {
                name: "Один процесс",
                tagline: "Начать с самого больного места",
                price: "15 000 000",
                priceNote: "сум, от",
                term: "3–5 недель",
                best: "Конкретная задача одного отдела",
                features: [
                    "Разбор и схема одного процесса",
                    "Система или модуль под этот процесс",
                    "2–3 интеграции (Telegram, платежи, Excel)",
                    "Настройка ролей и прав доступа: до 5 пользователей",
                    "Перенос существующих данных",
                    "Обучение сотрудников (1 сессия)",
                    "Месяц бесплатного сопровождения",
                ],
            },
            {
                name: "Уровень отдела",
                tagline: "Продажи, склад или сервис целиком",
                price: "45 000 000",
                priceNote: "сум, от",
                term: "2–3 месяца",
                best: "Автоматизация одного направления от и до",
                featured: true,
                features: [
                    "Разбор 3–5 связанных процессов",
                    "CRM или внутренняя система с ролями и правами",
                    "Модули склада, документов и отчётности",
                    "Интеграции с 1С, банком и платёжными системами",
                    "Дашборд для руководителя и выгрузки",
                    "Интерфейс, полноценно работающий в мобильном браузере",
                    "Видеоинструкции и 2 обучающие сессии",
                    "2 месяца бесплатного сопровождения",
                ],
            },
            {
                name: "Уровень компании",
                tagline: "Несколько отделов и филиалов",
                price: "110 000 000",
                priceNote: "сум, от",
                term: "4–8 месяцев",
                best: "Компаниям с филиалами или производством",
                features: [
                    "Полный аудит процессов и дорожная карта",
                    "План поэтапного внедрения",
                    "Модули уровня ERP: производство, финансы, кадры",
                    "Единая база данных между филиалами",
                    "Сложная система прав и журнал аудита",
                    "API-интеграции с текущими программами",
                    "Отказоустойчивая архитектура и резервные копии",
                    "Выделенный менеджер проекта и ежемесячный отчёт",
                ],
            },
        ],
    },

    process: {
        eyebrow: "Процесс",
        h: "Как идёт работа по автоматизации",
        sub: "Обычно от первой встречи до первого рабочего модуля проходит 4–8 недель.",
        steps: [
            {
                t: "Знакомство",
                time: "1 день",
                d: "Спрашиваем, какая работа отнимает больше всего времени. Уже на этой встрече честно говорим, будет ли автоматизация вам выгодна.",
            },
            {
                t: "Разбор процесса",
                time: "3–5 дней",
                d: "Говорим с сотрудниками, смотрим документы и файлы. На выходе — схема текущего процесса и расчёт теряемого времени.",
            },
            {
                t: "Решение и предложение",
                time: "2–4 дня",
                d: "Описываем, что закрывается готовой программой, а что требует своей системы. Фиксируем цену, сроки и этапы.",
            },
            {
                t: "Прототип",
                time: "1–2 недели",
                d: "Показываем ключевые экраны в Figma. Сотрудники пробуют работать с ними — неудобства находятся до написания кода.",
            },
            {
                t: "Разработка",
                time: "3–10 недель",
                d: "Собираем систему модулями. Каждые 2 недели показываем готовую часть, и вы проверяете её на своих данных.",
            },
            {
                t: "Перенос данных и тесты",
                time: "1–2 недели",
                d: "Данные из Excel или старой базы переносятся и сверяются. Какое-то время старый и новый порядок работают параллельно.",
            },
            {
                t: "Запуск и обучение",
                time: "1 неделя",
                d: "Обучаем сотрудников, выдаём видеоинструкции. В первый месяц быстро отвечаем на вопросы и правим шероховатости.",
            },
        ],
    },

    samples: {
        eyebrow: "Примеры",
        h: "Наши проекты по автоматизации",
        sub: "Работающие системы в лифтовом сервисе, логистике, обучении и промышленной безопасности.",
        cta: "Смотреть все проекты",
        slugs: ["tezlift", "elma-lms", "logistatrans", "firewise", "grandpharm"],
    },

    faq: {
        eyebrow: "Вопросы и ответы",
        h: "Частые вопросы",
        sub: "Отвечаем на то, о чём спрашивают чаще всего при обсуждении автоматизации.",
        items: [
            {
                q: "Сколько стоит автоматизация бизнеса?",
                a: "Автоматизация одного процесса начинается от 15 000 000 сум. Система для целого отдела — от 45 000 000 сум, комплексное решение для компании с филиалами — от 110 000 000 сум. Итоговая сумма зависит от числа процессов, интеграций и пользователей. Первый разбор бесплатный — после него присылаем письменное предложение.",
            },
            {
                q: "Сколько времени занимает автоматизация?",
                a: "Один процесс — 3–5 недель, система уровня отдела — 2–3 месяца, уровень компании — 4–8 месяцев. Большой проект мы делим на этапы: первый рабочий модуль обычно готов за 4–8 недель и начинает приносить пользу сразу. Ждать завершения всей системы не нужно.",
            },
            {
                q: "Может, проще купить готовую CRM?",
                a: "Часто да, и мы сами это посоветуем — готовое решение дешевле и запускается быстрее. Но готовая программа не знает ваших процессов. Если у вас своя формула расчёта, свои формы документов или нестандартная производственная логика, доработка коробки может выйти дороже собственной системы.",
            },
            {
                q: "Что будет с моими файлами в 1С и Excel?",
                a: "Они не пропадут. Данные из Excel и старой базы переносятся в новую систему и сверяются построчно. С 1С настраивается интеграция: нужные данные передаются автоматически, а бухгалтерия остаётся в привычной программе. Что именно переносить, а что оставить на месте, определяем вместе в начале проекта и фиксируем письменно.",
            },
            {
                q: "А если сотрудники не примут новую систему?",
                a: "Это самый частый риск проектов. Поэтому прототип мы показываем именно тем людям, которые будут работать в системе, и учитываем их замечания до написания кода. При запуске проводим обучение и выдаём видеоинструкции, а первый месяц старый и новый порядок могут работать параллельно.",
            },
            {
                q: "Когда автоматизация окупается?",
                a: "Конкретную цифру считаем на первом разборе: сколько часов экономится и сколько эти часы стоят. Для одного процесса типичный срок окупаемости — 6–12 месяцев. Если по расчёту выходит больше двух лет, мы прямо об этом скажем и не будем рекомендовать запуск проекта.",
            },
            {
                q: "Где хранятся данные и насколько это безопасно?",
                a: "Выбор за вами: сервер в Узбекистане, зарубежное облако или ваш собственный сервер. Доступ идёт по HTTPS, пароли хранятся в зашифрованном виде, каждое действие пишется в журнал. Система ролей ограничивает, кто что видит. Резервные копии делаются ежедневно, восстановление проверяется на практике.",
            },
            {
                q: "Кому принадлежит система?",
                a: "Вам. Код ведётся в вашем репозитории, все права на интеллектуальную собственность закрепляются за вами в договоре. При желании вы сможете продолжить развитие системы с другой командой — для этого передаём техническую документацию, описание архитектуры и настройки серверов. Никаких «ключей» или скрытых зависимостей у нас не остаётся.",
            },
            {
                q: "С какого процесса начать?",
                a: "С того, который отнимает больше всего времени и даёт больше всего ошибок. Чаще всего это приём заявок или складской учёт. Попытка охватить всё сразу растягивает проект и повышает риск. Когда первый этап запускается за 4–8 недель, команда переходит на новый порядок увереннее.",
            },
            {
                q: "Система будет работать на телефоне?",
                a: "Да. Все интерфейсы делаем полноценно работающими в мобильном браузере — продавец, мастер или кладовщик заходят с телефона. Если нужно отдельное мобильное приложение (например, ради офлайн-режима или сканера штрихкодов), оно оценивается как отдельный проект со своим сроком, бюджетом и планом внедрения.",
            },
            {
                q: "Подходит ли это малому бизнесу?",
                a: "Иногда да, иногда нет. Если в команде 3–5 человек и 20–30 заказов в месяц, сложная система избыточна. В таком случае хватает Telegram-бота, простой панели сбора заявок или готового сервиса — от 5 000 000 сум. Такой вариант мы тоже предлагаем и считаем нормальным.",
            },
            {
                q: "Нужна ли поддержка после запуска?",
                a: "Рекомендуем, но это не обязательное условие сотрудничества. Любая система должна меняться вместе с бизнесом: новый отчёт, новый филиал, изменения в законодательстве. Месячная поддержка начинается от 3 500 000 сум и включает мониторинг, резервные копии, мелкие доработки и исправление ошибок. Отказаться можно в любой месяц.",
            },
        ],
    },

    cta: {
        h: "Какая работа отнимает у вас больше всего времени?",
        p: "На бесплатном разборе посмотрим ваш процесс и назовём в цифрах, сколько времени и денег можно сэкономить. Если автоматизация не даст выгоды, скажем и об этом. Звоните: +998 90 954 12 62.",
        button: "Запросить бесплатный разбор",
        secondary: "Написать в Telegram",
    },

    images: [
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-hero.webp",
            alt: "Экран системы автоматизации бизнеса с заказами и складскими остатками",
            caption: "Заявки, склад и отчёты в одном окне — данные не нужно переносить руками.",
            prompt:
                "Wide hero image of a modern business dashboard on a desktop monitor in a bright office: order pipeline columns, inventory table, small charts, status badges. Clean light UI, blue and teal accents, abstract data (no readable company names). A person's hands rest near the keyboard, face not visible. Soft natural light, shallow depth of field, photographic, 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-before-after.webp",
            alt: "Сравнение ручной работы в Excel и автоматизированного процесса",
            caption: "Слева — разрозненные файлы и звонки. Справа — одна цепочка.",
            prompt:
                "Split illustration comparing two workflows. Left side: tangled arrows between paper documents, spreadsheet icons, phone and sticky notes, muted grey-red tones. Right side: one clean linear pipeline of connected nodes with checkmarks, calm blue-green tones. Flat vector infographic style, plenty of white space, no text labels. 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-integratsiya.webp",
            alt: "Схема интеграции CRM, склада, 1С, платёжной системы и Telegram",
            caption: "Интеграция — данные вводятся один раз и расходятся по остальным системам.",
            prompt:
                "Clean isometric diagram of connected business systems: a central hub connected by glowing lines to blocks labelled abstractly with icons — CRM, warehouse, accounting, bank/payment, messenger bot, analytics. Light background, soft shadows, blue and violet palette, no readable text. Technical but friendly infographic style. 16:9.",
        },
        {
            src: "/assets/img/services/biznes-avtomatlashtirish-dashboard.webp",
            alt: "Живой дашборд руководителя: продажи, остатки и просроченная дебиторка",
            caption: "Руководителю не нужно ждать конца месяца — цифры обновляются ежедневно.",
            prompt:
                "Analytics dashboard UI shown on a laptop screen: KPI cards, a line chart of sales trend, a bar chart by branch, a small table of overdue payments. Modern flat design, light theme with one accent color, generic placeholder numbers, no real brand names. Straight-on view on a wooden desk, subtle reflections. 16:9.",
        },
    ],

    related: ["crm-tizimlar", "erp-tizimlar", "telegram-bot", "veb-ilovalar", "ai-integratsiya"],
};

const content = { uz, ru };

export default content;
